export default __webpack_public_path__ + "_/images/fire-e35c5073712679d47683a9c11c5370ea2fe043837564108bccce04040bcb2395.svg";